import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';
import { SFDateComponent } from 'src/app/modals/sf-date/sf-date.component';
import { MatRadioModule } from '@angular/material/radio';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';

import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss'],
})
export class SettingComponent implements OnInit {
  // @ViewChild(DaterangepickerDirective) picker: DaterangepickerDirective;
  selectedDay: string = '';
  // days:any=[

  // 'Please select specific date range'
  // ]
  form: FormGroup;
  // favoriteSeason: string;
  // seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  contactdata;
  syncBasedOn: string;
  disable = false;
  dialogRef: any;
  contactdatalist: any = [];
  paginationProperty: any;
  submitted = false;
  regexStr = '^[0-9]*$';
  reg = '^((\\+91-?)|0)?[0-9]{11}$';
  response;
  data: any;
  value: string;

  remark: string;
  isButtonDisable: boolean = true;

  daterange = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  today = new Date();

  // formnew: FormGroup = new FormGroup({});
  model;

  customDate = false;
  currentD = this.datePipe.transform(this.today, 'DD MMM,YYYY');
  datepicker = [{ value: '5', viewValue: 'Custom Date' }];

  // selected: { startDate: Moment, endDate: Moment };

  invalidDates: moment.Moment[] = [];

  tooltips = [{ date: moment() }, { date: moment().add(2, 'days') }];

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public toastr: ToastrService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    public _userService: UserManagementService
  ) {}

  get f1() {
    return this.form.controls;
  }
  submit() {}

  startDateClicked($event) {
    // // moment().add(5, 'days')
    // this.minDate = moment($event.startDate._d ,'DD/MM/YYYY').add( 1 , 'y');
    // this.maxDate = moment($event.startDate._d ,'DD/MM/YYYY');
  }

  isInvalidDate = (m: moment.Moment) => {
    // Disbale Sundays and Saturdays
    // return moment(this.maxDate, "DD-MM-YYYY").add('years', 1)
  };

  isTooltipDate = (m: moment.Moment) => {
    const tooltip = m.format('DD MMM,YYYY');
    const type2 = moment(this.maxDate).format('DD MMM,YYYY');
    const tooltip1 = tooltip > type2;
    if (tooltip1) {
      return 'Select within one year!';
    } else {
      return false;
    }
  };

  // new code
  // new code end

  maxDate;
  minDate;
  dateLimit;
  wos;
  someRecords: boolean = false;
  // allRecords:boolean=false;
  ngOnInit(): void {
    // this.minDate=moment();
    this.dateLimit = 365;
    this.maxDate = moment(new Date());
    // this.minDate = moment(this.maxDate).subtract( 1 , 'y');
    this.minDate = moment(new Date(2016, 0, 1));

    this.form = this.fb.group({
      phoneNo: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{11}$'),
          Validators.minLength(11),
          Validators.maxLength(11),
        ],
      ],
      whatsupNo: [
        '',
        [
          Validators.required,
          Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      availabilityInMonth: [
        '',
        [
          Validators.required,
          Validators.pattern('^[1-6]*$'),
          Validators.minLength(1),
          Validators.maxLength(1),
        ],
      ],
      lastSynchStatus: ['', [Validators.required]],
      lastSynchDate: ['', [Validators.required]],
      updatedBy: ['', [Validators.required]],
      syncBasedOn: [''],
      selectedDate: [{ value: '', disabled: true }],
    });

    this.getContact();
    this.ontimeupdate();
  }

  checkRadio() {
    if (this.form.value.syncBasedOn == 'dateRange') {
      this.form.get('selectedDate').enable();
    } else {
      // this.form.get('selectedDate').setValue('')
      this.form.get('selectedDate').disable();
    }
  }

  onSync() {
    if (this.form.value.syncBasedOn) {
      // new code
      if (
        this.form.value.syncBasedOn == 'allRecords' &&
        this.form.value.syncBasedOn !== undefined
      ) {
        // if(this.form.value.syncBasedOn == 'dateRange'){
        // if(this.form.value.selectedDate.startDate && this.form.value.selectedDate.endDate){
        // confirm('select record?');
        var postdata = {
          fromDate: '',
          toDate: '',
        };
        this._userService.syncSFServerDetail(postdata).subscribe((data) => {
          this.response = data;

          if (this.response.result.messageCode == 0) {
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          }
          if (this.response.result.messageCode == 3) {
            this.toastr.error(this.response['result']['message'], 'Failed', {
              timeOut: 3000,
            });
          }
        });
        // new code
        // new code end

        // window.location.reload();
        // }
        // else{
        //   alert('Please select specific date range')
        // }
      }
      // new ode end
      if (this.form.value.syncBasedOn == 'dateRange') {
        // if(this.form.value.syncBasedOn == 'dateRange'){
        if (
          this.form.value.selectedDate !== undefined &&
          this.form.value.selectedDate !== undefined &&
          this.form.value.selectedDate.startDate &&
          this.form.value.selectedDate.endDate
        ) {
          var dayDiff = this.form.value.selectedDate.endDate.diff(
            this.form.value.selectedDate.startDate,
            'days'
          ); //Math.floor((Date.UTC(this.form.value.selectedDate.getFullYear(), this.form.value.selectedDate.getMonth(), this.form.value.selectedDate.getDate()) - Date.UTC(this.form.value.selectedDate.endDate.getFullYear(), this.form.value.selectedDate.endDate.getMonth(), this.form.value.selectedDate.endDate.getDate()) ) /(1000 * 60 * 60 * 24));
          if (
            dayDiff > 364 &&
            this.form.value.selectedDate.startDate <
              moment(new Date(2016, 0, 1))
          ) {
            alert('Please select specific date range from 2016 within 1 year');
            return;
          }
          confirm('Are you sure you want to sync SF server?');
          this.spinner.show();
          setTimeout(() => {
            this.spinner.hide();
          }, 3000);

          // {

          //   this.toastr.error(this.response['result']['message'], 'Error', {

          //     timeOut: 3000,

          //   });

          // }

          var postdata1 = {
            // "fromDate": this.form.value.selectedDate.startDate._d ,
            // "toDate": this.form.value.selectedDate.endDate._d ,
            fromDate: this.startdata,
            toDate: this.enddata,
          };

          this._userService.syncSFServerDetail(postdata1).subscribe((data) => {
            this.response = data;

            this.spinner.hide();
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
            this.sharedate = null;
            this.form.get('selectedDate').disable();
          });
          // window.location.reload();
        } else {
          alert('Please select specific date range');
        }
      } else {
        confirm('Are you sure you want to sync SF server?');
      }
    } else {
      alert('Please select atleast any one Records!');
    }
    // this.ontimeupdate() ;
    // this.form.value.selectedDate.reset;
    // window.location.reload();
  }

  openDatePicker() {
    this.pickerDirective.open();
  }

  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  @ViewChild('date-picker') datePicker: DaterangepickerDirective;
  sharedate;
  startdata;
  enddata;
  picker2;
  sharedate2;
  datePickerInput;
  onDateRangeChanged1(dates, ID, event: any) {
    this.sharedate = dates;
    this.picker2 = ID;
    this.someRecords = true;
    //  this.allRecords=false

    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      // this.enddata = dates.endDate ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd HH:mm:ss') : null;
      // this.startdata = dates.startDate ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd HH:mm:ss') : null;
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'MM-dd-yyyy')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'MM-dd-yyyy')
        : null;
    }
  }
  //   onDate(){
  // this.allRecords=true;
  //  this.someRecords=false;
  //   }

  onClear() {
    this.dialogRef.close();
  }

  onItemChange(value) {}
  getContact() {
    this._userService.getContactlist().subscribe((data) => {
      this.contactdata = data;
      this.contactdatalist = this.contactdata.result.data;
      this.form.patchValue({
        phoneNo: this.contactdatalist.phoneNo,
        whatsupNo: this.contactdatalist.whatsupNo,
        availabilityInMonth: this.contactdatalist.availabilityInMonth,
        lastSynchStatus: this.form.value.lastSynchStatus,
        lastSynchDate: this.form.value.lastSynchDate,
        updatedBy: this.form.value.updatedBy,
      });
    });
  }

  checkValue(value, event) {
    if (value === 'phoneNo') {
      this.contactdatalist.phoneNo === event.target.value
        ? (this.isButtonDisable = true)
        : (this.isButtonDisable = false);
    } else if (value === 'whatsupNo') {
      this.contactdatalist.whatsupNo === event.target.value
        ? (this.isButtonDisable = true)
        : (this.isButtonDisable = false);
    } else {
      this.contactdatalist.availabilityInMonth === +event.target.value
        ? (this.isButtonDisable = true)
        : (this.isButtonDisable = false);
    }
  }

  onSubmit() {
    this.submitted = true;
    // if (this.form.valid) {
    if (
      this.form.value.availabilityInMonth > 7 &&
      this.form.value.whatsupno === '' &&
      this.form.value.phoneno === ''
    ) {
      var pattern = new RegExp(this.reg);
      var result = pattern.test(
        this.form.value.availabilityInMonth ||
          this.form.value.whatsupn ||
          this.form.value.phoneno
      );
      if (result == false) {
        // alert('Please enter valid month')
        alert('Please fill all fields and enter valid values');
        return false;
      }
    }
    // // this.spinner.show();
    var formdata = {
      phoneno: this.form.value.phoneNo,
      whatsupno: this.form.value.whatsupNo,
      availabilityInMonth: this.form.value.availabilityInMonth,
    };
    if (confirm('Do you want to update this data?')) {
      const dialogRef = this.dialog.open(SettingDeletePopup, {});

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          var postBody = {
            phoneno: this.form.value.phoneNo,
            whatsupno: this.form.value.whatsupNo,

            availabilityInMonth: this.form.value.availabilityInMonth,
            remark: result,
          };

          this._userService.postContactUsDetail(postBody).subscribe((data) => {
            this.response = data;

            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
            // this.getContact()
            //  this.spinner.show();
          });
        }
      });
    }
    //   this.toastr.error(this.response.result.message, 'Error', {
    //     timeOut: 3000,
    //   });

    //   }

    // }
    // this.spinner.hide();

    // }
    // else{
    //   alert("Please fill all fields and enter valid values")
    // }
  }
  ontimeupdate() {
    this._userService.getContactlist().subscribe((data) => {
      this.totalData = data;
      this.avgData = this.totalData.result.data;
    });
  }

  onClose() {
    // window.location.reload();
    this.form.reset();

    //  this.dialogRef.close();
  }

  daterangepicker;
  totalData;
  avgData;

  // onselectDate(){
  //   var postdata= {
  //     daterangepicker: this.form.value({
  //       fromDate: '',
  //       toDate: ''
  //     })

  //   }
  //   this._userService.syncSFServerDetail(postdata).subscribe(data => {
  //         this.response = data;

  //         this.toastr.success(this.response.result.message, 'Success', {
  //           timeOut: 3000,
  //         });
  //       })
  // }

  get whatsupNo() {
    return this.form.get('whatsupNo');
  }
  get phoneNo() {
    return this.form.get('phoneNo');
  }

  get f() {
    return this.form.controls;
  }
}

@Component({
  selector: 'setting-delete-popup',
  templateUrl: 'setting-delete-popup.html',
})
export class SettingDeletePopup {
  formdelet: FormGroup;
  response;
  form: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<SettingDeletePopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formdelet = this.fb.group({
      remark: ['', [Validators.required]],
    });
  }
  onSubmits() {
    if (this.formdelet.valid) {
      this.dialogRef.close(this.formdelet.value.remark);
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
